<template>
  <div>
    <div class="panel">
      <div class="title">
        Holden Physician Panel
      </div>
    </div>

    <div class="logo">
      <div class="left">
        <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/hxl.png">
        <div class="value">
          Our proprietary panel of
          verified healthcare professionals
        </div>
      </div>

      <div class="right">
        <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/appa/APPA.png">
        <div class="value">
          A Strategic trust panel alliance across Asia + India
        </div>
      </div>
    </div>

    <div class="Verification">
      <div class="img">
        <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/physician/iconPhysician.png">
      </div>
      <div class="text">
        <div class="title">
          Physician recruitment is tailored to your research needs with questions designed to elicit answers you need to hear.

        </div>
        <div class="value">
          <div class="one">
            We have a strict validation process to make sure every HCP panelist is Real, Reliable, and Available.

          </div>
          <div class="two">
            A project cannot be successfully completed without the right people involved. Recruitment success goes beyond tracking down your precise target and convincing them to participate in your study. When researchers meet these physicians, the physicians must be able to express themselves clearly and knowledgeable on the subject matter.

          </div>
        </div>
      </div>
    </div>

    <!-- Picture of Doctors and/or Events -->
    <div class="picture">
      <div class="box" @click="$router.push('/interview?source=physician')">
        <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/physician/interview.jpg">
        <div class="value">In-depth Interview</div>
      </div>
      <div class="box" @click="$router.push('/focus?source=physician')">
        <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/physician/focusGroup.jpg">
        <div class="value">Focus group</div>
      </div>
      <div class="box">
        <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/physician/patientRecordForm.jpg">
        <div class="value">Patient Record Form</div>
      </div>
      <div class="box" @click="$router.push('/onlinesurvey?source=physician')">
        <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/physician/onlineSurvey.jpg">
        <div class="value">Online Survey</div>
      </div>
      <div class="box">
        <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/physician/productTesting.jpg">
        <div class="value">Product Testing</div>
      </div>
      <div class="box">
        <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/physician/onlineVulletinBoard.jpg">
        <div class="value">Online Bulletin Board</div>
      </div>
    </div>

    <!-- Asia Access -->
    <asia-map />

    <!-- Download our Panel Book -->
    <down-load />

    <!-- case study -->
    <case-study />

  </div>
</template>

<script>
import { panelDownloads, getNewsList, getCustomerList, advertisementFlow } from "@/api/api";
import DownLoad from "@/components/downLoad";
import CaseStudy from "@/components/caseStudy";
import AsiaMap from "@/components/asiaMap";

export default {
  data() {
    return {
      caseList: [],
      downloadfile: "",
      url: "",
      downloadid: ""
    };
  },
  created() {
    this.getCustomerList();
    this.loading();
    this.advertisementFlow(); // 在组件创建时加载Google代码
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://www.googletagmanager.com/gtag/js?id=AW-11335422054";
    document.head.appendChild(script);
    script.onload = () => {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        dataLayer.push(arguments);
      }
      gtag("js", new Date());
      gtag("config", "AW-11335422054");
    };
    this.webinercookies();
  },
  components: { DownLoad, CaseStudy, AsiaMap },
  methods: {
    webinercookies() {
      // 如果没有记录cookie
      if (!localStorage.getItem("webinersource")) {
        // 就不重新赋值
        let webinersource = this.$route.query.source;

        if (webinersource == undefined) {
          localStorage.setItem("webinersource", "www");
        } else {
          localStorage.setItem("webinersource", webinersource);
        }
        // console.log(1);
      } else {
        // 如果没有cookie就设置cookie
      }
    },
    advertisementFlow() {
      // 如果没有source
      if (this.$route.query.source == undefined) {
        // console.log(1);
        // 就把source拼接
        advertisementFlow({
          path: "physicians",
          source: "",
          information: "Products Physicians"
        }).then(res => {
          if (res.code == 10000) {
            // console.log(res);
          }
        });
        // 如果有source
      } else {
        advertisementFlow({
          path: "physicians",
          source: this.$route.query.source,
          information: "Products Physicians"
        }).then(res => {
          if (res.code == 10000) {
            // console.log(res);
          }
        });
      }
    },
    loading() {
      this.$loading({
        lock: true,
        background: "rgba(255, 255, 255,1)"
      });
      setTimeout(() => {
        this.$loading().close();
      }, 700);
    },
    getCustomerList() {
      getCustomerList({
        pageSize: 4,
        pageIndex: 1,
        status: 1, //启用
        origin: 1, //前台
        isRecommend: 1, //是否推荐
        customerType: 1
      }).then(res => {
        if (res.code != 10000) {
          this.$message.error(res.msg || "查询案例分享失败");
          return;
        }
        this.caseList = res.datalist || [];
        this.allCount = res.allCount;
      });
    },
    toDetail(id) {
      this.$router.push({ name: "caseDetail", query: { id: id } });
    },
    btn(path) {
      // 跳转页面
      this.$router.push({
        path
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.panel {
  background-color: #2cb1e9;

  .title {
    padding: 50px 120px;
    color: #fff;
    font-size: 40px;
    font-weight: 700;
  }
}

.logo {
  display: flex;
  flex-wrap: wrap;
  text-align: center;
  padding: 0 120px;
  height: 450px;

  .value {
    margin-top: 65px;
  }

  .left,
  .right {
    width: 50%;
    padding: 0 5%;
    margin: 80px 0;
    font-size: 20px;

    img {
      height: 40%;
    }
  }

  .left {
    border-right: 1px dashed #000;

    .value {
    }
  }
}
.Verification {
  background-color: #fff;
  display: flex;
  padding: 50px 120px;
  justify-content: space-between;

  img {
    width: 320px;
    margin-top: 50px;
  }
  .text {
    width: 65%;
    .title {
      font-size: 30px;
      font-weight: 700;
      margin-bottom: 50px;
      color: #2cb1e9;
    }
    .value {
      font-size: 23px;
      & > * {
        margin-top: 20px;
      }
    }
  }
}
.picture {
  padding: 80px 230px;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;

  .box {
    cursor: pointer;
    width: 27%;
    position: relative;
    margin-bottom: 30px;

    img {
      width: 100%;
    }

    .value {
      font-size: 23px;
      text-align: center;
      vertical-align: bottom;
      position: absolute;
      bottom: 0;
      background-color: #2cb1e9;
      color: #fff;
      line-height: 50px;
      width: 100%;
    }
  }
}

.casetitle {
  font-size: 40px;
  font-weight: 700;
  padding: 50px 120px 0 120px;
}

@media screen and (max-width: 576px) {
  .panel {
    .title {
      font-size: 80px;
    }
  }
  .logo {
    height: 1800px;
    .left,
    .right {
      width: 100%;
      border: none;
    }
    .left {
      img {
        width: 40%;
        height: 60%;
      }
    }
    .value {
      font-size: 80px;
    }
  }
  .text {
    .left,
    .right {
      margin: 100px 0;
      font-size: 40px;
    }
  }
  .Verification {
    img {
      width: 600px;
    }
    display: block;
    .text {
      width: 100%;
      .title {
        font-size: 80px;
      }
      .value {
        font-size: 70px;
      }
    }
  }

  .picture {
    padding: 50px 130px;

    .box {
      width: 80%;

      .value {
        font-size: 80px;
        line-height: 200px;
      }
    }
  }

  .casetitle {
    font-size: 80px;
  }
}
</style>
<style lang="scss" scoped>
@media screen and (max-width: 576px) {
  /deep/ .el-dialog__wrapper {
    .el-dialog {
      width: 80% !important;

      .el-dialog__footer {
        .el-button {
          font-size: 35px;
        }
      }
    }
  }
}
</style>